import {useApolloClient, useMutation} from "@apollo/client";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {CurrentUserContext, GQL_UPDATE_CURRENT_USER_UI_SETTINGS, GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {UiSettings} from "@/lib/types/accounts.ts";

const UI_SETTINGS_DEFAULT: UiSettings = {
  table_page_size: 10,
};

export const useUiSettings = () => {
  const {user} = useCurrentUserContext();
  const client = useApolloClient();
  const [updateUiSettingsMutation] = useMutation(GQL_UPDATE_CURRENT_USER_UI_SETTINGS);

  const userSettings = Object.fromEntries(
    Object.entries(user?.ui_settings ?? {}).filter(([, value]) => value !== null)
  );
  const uiSettings: UiSettings = {...UI_SETTINGS_DEFAULT, ...userSettings};

  const updateUiSettings = (newSettings: UiSettings): void => {
    if (!user) {
      return;
    }

    const merged = {...uiSettings, ...newSettings};

    const cachedData = client.readQuery<CurrentUserContext>({query: GQL_USER_CONTEXT});
    if (cachedData?.user) {
      client.writeQuery({
        query: GQL_USER_CONTEXT,
        data: {
          ...cachedData,
          user: {
            ...cachedData.user,
            ui_settings: merged,
          },
        },
      });
    }

    updateUiSettingsMutation({variables: {data: merged}});
  };

  return {uiSettings, updateUiSettings};
};
